import React, { useState } from 'react';
import PropTypes from 'prop-types';

// redux
import { useDispatch, useSelector } from 'react-redux';
import {
	setGlobalBundleRuleTranslation,
	updateGlobalBundleRuleTranslation,
	resetState,
} from './store/globalBundleRuleTranslations.actions';

// components
import { ReactDataWrapper } from 'reactDataWrapper';
import GlobalBundleRuleTranslationsModalBatch from './components/batch/globalBundleRuleTranslationsModalBatch';
import { Tooltip, Icon, Button, Input } from 'dumb';

// services
import {
	fetchAllGlobalBundleRuleTranslations,
	deleteGlobalBundleRuleTranslation,
	editGlobalBundleRuleTranslations,
} from './globalBundleRuleTranslations.service';

// utils
import { getEditedValues } from 'services/utils';

// phrases
import phrases from './globalBundleRuleTranslations.phrases';

const columns = [
	{
		Header: 'Name',
		id: 'name',
		accessor: 'name',
		filterPath: ':name',
	},
	{
		Header: 'Language',
		id: 'language',
		accessor: 'language.name',
		filterPath: ':language.name',
	},
];

const GlobalBundleRuleTranslations = ({ id }) => {
	const dispatch = useDispatch();
	const { tableKey, globalBundleRuleTranslation, originalGlobalBundleRuleTranslation } = useSelector(
		(store) => store.globalBundleRuleTranslations
	);

	const [showBatchModal, setShowBatchModal] = useState(false);

	// crud
	const fetchData = (state) => fetchAllGlobalBundleRuleTranslations(id, state);
	const editEntry = () => {
		const valuesToEdit = getEditedValues({
			newData: globalBundleRuleTranslation,
			oldData: originalGlobalBundleRuleTranslation,
		});

		const payload = {
			id: globalBundleRuleTranslation.id,
			name: valuesToEdit.name,
		};

		return editGlobalBundleRuleTranslations(payload);
	};
	const deleteEntry = (id) => deleteGlobalBundleRuleTranslation(id);

	// crud prep
	const setInitialEditValues = (data) => {
		const body = {
			id: data.id,
			name: data.name,
			language: data.language.name,
		};

		dispatch(setGlobalBundleRuleTranslation(body));
	};
	const getEditableCells = () => [
		{
			header: 'Name',
			value: (
				<Input
					id="name"
					placeholder={phrases.NAME}
					value={globalBundleRuleTranslation.name}
					onChange={(event) => dispatch(updateGlobalBundleRuleTranslation({ name: event.target.value }))}
				/>
			),
		},
		{
			header: 'Language',
			value: <span>{globalBundleRuleTranslation.language}</span>,
		},
	];

	const toggleBatchModal = () => setShowBatchModal(!showBatchModal);
	const onRdwModalClose = () => dispatch(resetState());

	return (
		<>
			<ReactDataWrapper
				key={tableKey}
				accessAreasAllowedToEdit={['Sales Configuration']}
				title={phrases.TITLE}
				columns={columns}
				fetchData={fetchData}
				filterable
				defaultPageSize={10}
				reduxKey={`${id}-product/global_bundle_rule_translations`}
				manual
				editableCells={getEditableCells()}
				setInitialEditValues={setInitialEditValues}
				onModalClose={onRdwModalClose}
				deleteEntry={deleteEntry}
				editEntry={editEntry}
				actionRender={
					<Tooltip
						text={phrases.BATCH_ADD}
						renderData={(ref, onMouseEnter, onMouseLeave) => (
							<Button
								label="Add"
								shadow
								type="inverted"
								onClick={toggleBatchModal}
								refProp={ref}
								onMouseEnter={onMouseEnter}
								onMouseLeave={onMouseLeave}
							>
								<Icon name="add" />
							</Button>
						)}
					/>
				}
			/>

			{showBatchModal && <GlobalBundleRuleTranslationsModalBatch onClose={toggleBatchModal} id={id} />}
		</>
	);
};

GlobalBundleRuleTranslations.propTypes = {
	id: PropTypes.number,
};

export default GlobalBundleRuleTranslations;
